<template>
    <div class="form">
        <h4 class="step-title">
            {{ appState.messageTitle }}
        </h4>
            <div class="step-content d-flex flex-column align-items-center">
                <div class="step-item">
                    <div class="form-group mb-0">
                        {{ appState.message }}
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
    export default {
        name: "Message",
        props: {
            appState: Object
        }
    }
</script>

<style scoped>
.step-item {
    background-color: transparent !important;
    color: white;
    white-space: normal;
    word-wrap: break-word;
    height: 100%;
}
</style>
